import { createContext, useContext, useState } from 'react';

const AppVersionContext = createContext(null);

export function AppVersionProvider({ children }) {
  const [version, setVersionState] = useState(() => localStorage.getItem('app_version') || 'v1');

  function setVersion(v) {
    localStorage.setItem('app_version', v);
    setVersionState(v);
    window.dispatchEvent(new Event('storage'));
  }

  function toggleVersion() {
    setVersion(version === 'v1' ? 'v2' : 'v1');
  }

  return (
    <AppVersionContext.Provider
      value={{ version, setVersion, isV2: version === 'v2', toggleVersion }}
    >
      {children}
    </AppVersionContext.Provider>
  );
}

const DEFAULT_VERSION = {
  version: 'v1',
  setVersion: () => {},
  isV2: false,
  toggleVersion: () => {},
};

export function useAppVersion() {
  return useContext(AppVersionContext) ?? DEFAULT_VERSION;
}
